import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { EstudianteService } from '../../../../services/estudiante/estudiante.service';
import { StudentDashboardData } from '../../../../core/models/estudiante/estudiante.model';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-dashboard-estudiante',
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        MatIconModule,
    ],
    templateUrl: './dashboard-estudiante.html',
})
export class DashboardEstudiante implements OnInit {

    loading: boolean = false;
    studentData: StudentDashboardData | null = null;

    constructor(
        private estudianteService: EstudianteService,
        private toastr: ToastrService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.loadStudent();
    }

    private loadStudent(): void {
        setTimeout(() => {
            this.loading = true;
            this.estudianteService.getStudentDashboard().subscribe({
                next: (res: any) => {
                    this.loading = false;
                    if (res.success === 1 && res.data) {
                        this.studentData = res.data;
                    } else if (res.success === 0) {
                        const msg = res.errors?.length > 0 ? res.errors[0].message : res.message;
                        this.toastr.warning(msg || 'No se pudo cargar tu información de estudiante.', 'Advertencia');
                    }
                    this.cdr.detectChanges();
                },
                error: (err: any) => {
                    this.loading = false;
                    const msg = err.error?.errors?.[0]?.message || err.error?.message || 'Error de conexión';
                    this.toastr.error(msg, 'Error');
                    this.cdr.detectChanges();
                }
            });
        });
    }
}
